import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FondsPropresRoutingModule } from './fonds-propres-routing.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { PortefeuillesComponent } from './portefeuilles/portefeuilles.component';
import { ImportationsComponent } from './import-portefeuilles/importations/importations.component';
import { ImportationDetailsComponent } from './import-portefeuilles/importation-details/importation-details.component';
import { NgbdModalConfirm } from './services/modal-confirm';
import { AddItemModalComponent } from './import-portefeuilles/importations/add-item-modal/add-item-modal.component';
import { ViewItemDetailComponent } from './import-portefeuilles/importation-details/view-item-detail/view-item-detail.component';
import { ItemDetailComponent } from './import-portefeuilles/importation-details/item-detail/item-detail.component';
import { ItemGarantieComponent } from './import-portefeuilles/importation-details/item-garantie/item-garantie.component';
import { ItemSyntheseComponent } from './import-portefeuilles/importation-details/item-synthese/item-synthese.component';
import { ViewItemModalComponent } from './import-portefeuilles/importations/view-item-modal/view-item-modal.component';
import { ItemRuleComponent } from './import-portefeuilles/importation-details/item-rule/item-rule.component';
import { ParametreNotationComponent } from './parametres/parametre-notation/parametre-notation.component';
import { ParametreEntityPondereeComponent } from './parametres/parametre-entity-ponderee/parametre-entity-ponderee.component';
import { ParametrePondereComponent } from './parametres/parametre-pondere/parametre-pondere.component';
import { TypeFinancementComponent } from './parametres/type-financement/type-financement.component';
import { TypeGarantieComponent } from './parametres/type-garantie/type-garantie.component';
import { RuleManagementComponent } from './parametres/rule-management/rule-management.component';
import { SegmentationPrudentielleComponent } from './parametres/segmentation-prudentielle/segmentation-prudentielle.component';
import { PortefeuilleDetailsComponent } from './portefeuilles/portefeuille-details/portefeuille-details.component';
import { DetailsComponent } from './portefeuilles/portefeuille-details/details/details.component';
import { ItemCreditComponent } from './portefeuilles/portefeuille-details/details/item-credit/item-credit.component';
import { SegmentAprDetailsComponent } from './portefeuilles/portefeuille-details/segment-apr-details/segment-apr-details.component';
import { ConsommationFondsPropresComponent } from './portefeuilles/portefeuille-details/consommation-fonds-propres/consommation-fonds-propres.component';
import { CreditComponent } from './portefeuilles/portefeuille-details/details/item-credit/item/credit/credit.component';
import { GarantieComponent } from './portefeuilles/portefeuille-details/details/item-credit/item/garantie/garantie.component';
import { RuleComponent } from './portefeuilles/portefeuille-details/details/item-credit/item/rule/rule.component';
import { SyntheseComponent } from './portefeuilles/portefeuille-details/details/item-credit/item/synthese/synthese.component';
import { ParametreGeneralComponent } from './parametres/parametre-general/parametre-general.component';
import { EditModalComponent } from './parametres/parametre-general/edit-modal/edit-modal.component';
import { NotationModalComponent } from './parametres/parametre-notation/notation-modal/notation-modal.component';
import { PondereModalComponent } from './parametres/parametre-pondere/pondere-modal/pondere-modal.component';
import { BenchmarkComponent } from './portefeuilles/portefeuille-details/benchmark/benchmark.component';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  declarations: [
    PortefeuillesComponent, 
    ImportationsComponent, 
    ImportationDetailsComponent, 
    NgbdModalConfirm, 
    AddItemModalComponent, 
    ViewItemDetailComponent, 
    ItemDetailComponent, 
    ItemGarantieComponent, 
    ItemSyntheseComponent, 
    ViewItemModalComponent, 
    ItemRuleComponent, 
    ParametreNotationComponent, 
    ParametreEntityPondereeComponent, 
    ParametrePondereComponent, 
    TypeFinancementComponent, 
    TypeGarantieComponent, 
    RuleManagementComponent, 
    SegmentationPrudentielleComponent, DetailsComponent,  ItemCreditComponent,
    PortefeuilleDetailsComponent, SegmentAprDetailsComponent, ConsommationFondsPropresComponent, CreditComponent, GarantieComponent,
    RuleComponent, SyntheseComponent, ParametreGeneralComponent, EditModalComponent,NotationModalComponent, NotationModalComponent, PondereModalComponent,
    BenchmarkComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FondsPropresRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ChartsModule
  ],
  entryComponents: [
    AddItemModalComponent, 
    ViewItemModalComponent, ViewItemDetailComponent, 
    NgbdModalConfirm,
    ItemCreditComponent,
    EditModalComponent,
    NotationModalComponent,
    PondereModalComponent
  ]
})
export class FondsPropresModule { }
